import React from 'react';
import { Container, Typography, Box, Paper, Divider, Stack, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function DeleteAccount() {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Delete Your Account
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          QuestGuru — operated by Arithmetic Infotech
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Stack spacing={3}>
          <Box>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Option 1 — Delete directly from the app
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You can delete your account and all associated data directly from the QuestGuru mobile app:
            </Typography>
            <Box component="ol" sx={{ pl: 2.5, mt: 1.5, color: 'text.secondary' }}>
              <li>Open the QuestGuru app</li>
              <li>Go to <strong>Profile</strong> (bottom navigation)</li>
              <li>Tap <strong>Delete Account</strong></li>
              <li>Confirm the deletion</li>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              This immediately and permanently deletes your account and all your personal data from our systems.
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Option 2 — Submit a deletion request by email
            </Typography>
            <Typography variant="body1" color="text.secondary">
              If you no longer have access to the app, send an email to:
            </Typography>
            <Typography
              variant="body1"
              fontWeight={600}
              sx={{ mt: 1, color: 'primary.main' }}
              component="a"
              href="mailto:support@arithmeticinfotech.com?subject=Account Deletion Request"
            >
              support@arithmeticinfotech.com
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Include the email address associated with your QuestGuru account. We will process your request within 7 business days.
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              What data is deleted
            </Typography>
            <Box component="ul" sx={{ pl: 2.5, color: 'text.secondary' }}>
              <li>Your account profile (name, email)</li>
              <li>All study progress and exam history</li>
              <li>Chat history and AI-generated content</li>
              <li>All other personal data associated with your account</li>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Some anonymised, aggregated data (not linked to your identity) may be retained for improving the service.
            </Typography>
          </Box>

          <Box sx={{ pt: 1 }}>
            <Button component={RouterLink} to="/privacy" variant="text" sx={{ pl: 0 }}>
              View our Privacy Policy →
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
}
